import sliceCreator from '../../index.js';
import {CREATE_ORDER} from '../../../constants/index.js';
const _createOrderAction = sliceCreator('CREATE_ORDER',CREATE_ORDER, 'post');

const { asyncAction: createOrderAction, reducer, clearData: clearCreateOrderData } = _createOrderAction;

export default reducer;

export {
    createOrderAction,
    clearCreateOrderData
}


